import {
  ComplianceControlExceptions as ControlExceptions,
  ComplianceControlExceptionsProps,
} from "~/pages/compliance/Control/ControlOutlets";

const FrameworkControlExceptionsEntryPage =
  ({}: ComplianceControlExceptionsProps) => {
    return <ControlExceptions />;
  };

export default FrameworkControlExceptionsEntryPage;
